module.exports = __webpack_public_path__ + "img/logo-full.25eb3a34.png";